import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setMentionNotificationEnabled: YJSChangeHandler<
  DatabaseChangeType.SET_MENTION_NOTIFICATION_ENABLED
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.mentionNotificationEnabled = change.mentionNotificationEnabled;
  });
};
